// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1YDRc","choiceBoxes":"toolbarselects_choiceBoxes__3AROE","simpleField":"toolbarselects_simpleField__2wO4x"};